let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a7mfu")).then(() => parcelRequire('3j3aK'));